var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAaveV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.5C0 7.66344 7.16344 0.5 16 0.5C24.8366 0.5 32 7.66344 32 16.5C32 25.3366 24.8366 32.5 16 32.5C7.16344 32.5 0 25.3366 0 16.5Z",
    fill: "url(#paint0_linear_573_18851)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83325 16.676C6.83193 11.517 10.9368 7.3335 15.9999 7.3335C21.0626 7.3335 25.1675 11.517 25.1666 16.676H22.8248C22.8248 12.8097 19.7934 9.67507 15.9999 9.67507C12.2065 9.67507 9.17506 12.8097 9.17506 16.676H6.83325ZM13.5659 16.8959C14.5957 16.8959 15.4306 16.061 15.4306 15.031C15.4306 14.0011 14.5957 13.1662 13.5659 13.1662C12.5361 13.1662 11.7012 14.0011 11.7012 15.031C11.7012 16.061 12.5361 16.8959 13.5659 16.8959ZM18.4397 16.8959C19.4696 16.8959 20.3045 16.061 20.3045 15.031C20.3045 14.0011 19.4696 13.1662 18.4397 13.1662C17.4099 13.1662 16.5751 14.0011 16.5751 15.031C16.5751 16.061 17.4099 16.8959 18.4397 16.8959Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.5C16 20.0817 19.5817 16.5 24 16.5C28.4183 16.5 32 20.0817 32 24.5C32 28.9183 28.4183 32.5 24 32.5C19.5817 32.5 16 28.9183 16 24.5Z",
    fill: "url(#paint1_linear_573_18851)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7466 28V21H23.0466V28H21.7466ZM24.9399 28V21H26.2399V28H24.9399Z",
    fill: "#F6F8F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_573_18851",
    x1: 16,
    y1: 0.5,
    x2: 16.1028,
    y2: 32.4997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9391F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6562F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_573_18851",
    x1: 24,
    y1: 16.5,
    x2: 24,
    y2: 31.3571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A242B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaveV2);
export default __webpack_public_path__ + "static/media/aave-v2.963b017caa5c39cdd571e80eb7e71247.svg";
export { ForwardRef as ReactComponent };